import Cloudsearch from './cloudsearch';
import { DateTime } from 'luxon';
const Handlebars = require('handlebars');

class MediaPresence extends Cloudsearch {
  constructor() {
    super();

    //Sample code, delete if works
    //this.showPagination( 0 );
    this.size = 5;
    this.topic = 'media-presence';
    this.fq = "(and topic:'" + this.topic + "' description:'" + window.search_description + "')";
    this.default_fq = {
      topic: this.topic,
      //content_language: document.querySelector('html').getAttribute('lang').split('-')[0],
    };
    this.previewSize = 25;
    this.filterTimer = 0;

    this.setupEvents();
  }

  showMediaPresenceInfo(event) {
    //console.log('inside the class', event.target);
    let text_to_search = event.currentTarget.querySelector('a').innerText;
    //document.querySelector('')
    let predictiveText = document.querySelector('#media-presence_predictiveText');
    predictiveText.querySelector('.predictiveText__menu').blur();
    //this.word = text_to_search;
    predictiveText.querySelector('input').value = text_to_search;
    predictiveText.querySelector('input').setAttribute('value', text_to_search);
    predictiveText.querySelector('button').click();
  }

  async predictiveSearchMedia(word) {
    //let coincidences = this.all_terms.filter(v => v.text.toUpperCase().includes(word.toUpperCase()));
    let coincidences = [];
    if (document.querySelector('.media-presence') != null) {
      //document.querySelector("#q").innerHTML = '"' + word + '"';

      let search_data = {
        arr_return_vars: ["title"],
        keyword: word,
        size: this.previewSize,
        start: 0,
        options: "{fields:['title^5', 'topic^4', 'category^3', 'description^2']}",
        fq: this.fq,
        sort: '_score desc',
        parser: "lucene",
      };

      let search_options = {
        //mode: 'no-cors'
      };

      if ( location.host == this.prod_hosts[0] || location.host == this.sandbox_hosts[0] ) {
        search_options.headers = this.openweb_header;
      }

      return fetch(this.parseSearchUrl(search_data), search_options)
        .then(response => response.json())
        .then(result => {
          if (result.data.hits != undefined) {
            if (result.data.hits.found > 0) {
              //let matches = [];
              result.data.hits.hit.forEach(hit => {
                coincidences.push({
                  link: '#',
                  text: hit.fields.title,
                });
              });
              return coincidences;
            } else {
              coincidences.push({
                link: '#', text: 'No se encontraron coincidencias',
              });
              return coincidences;
            }
          }
        })
        .catch(function (err) {
          console.log("Error on fetch", err);
          coincidences.push({
            link: '#', text: 'No se encontraron coincidencias',
          });
          return coincidences;
        });
    }
  }

  setupEvents() {
    document.addEventListener("DOMContentLoaded", () => {
      if( null !== document.querySelector('.media-presence__results') ) {
        this.showLatestMediaPresenceView();
      }
    });

    if( null !== document.querySelector('#media-presence_predictiveText .search-btn') ) {
      document.querySelector('#media-presence_predictiveText .search-btn').addEventListener('click', () => {
        let search_input = document.querySelector('#media-presence_predictiveText input');
        this.word = search_input.getAttribute('value') != undefined?search_input.getAttribute('value'):'';
        search_input.blur();
        //document.querySelector('.media-presence__results').scrollIntoView({behavior: 'smooth'});
        window.scroll({
          top: 400,
          behavior: 'smooth',
        });
        this.applyFilter(false);
        this.querySearch();
      });
    }

    /**
     * Show/Hide filters on mobile
     */
    if (screen.width < 960 && null !== document.querySelector('.media-presence__card') ) {
      document.querySelector('.media-presence__card').classList.toggle('media-presence__card-mobile');
    }

    if( null != document.querySelector('.media-presence__filters-mobile a') ) {
      document.querySelector('.media-presence__filters-mobile a').addEventListener('click', (event) => {
        event.preventDefault();
        document.querySelector('.media-presence__card').classList.toggle('media-presence__card-mobile');
      });
    }

    window.addEventListener('resize', () => {
      if (screen.width < 960 && null !== document.querySelector('.media-presence__card') ) {
        document.querySelector('.media-presence__card').classList.toggle('media-presence__card-mobile');
      }
    });

    /**
     * Filters events
     */
    let checkboxes = ['date', 'topic'];
    let selectors = checkboxes.map(keyword => '.media-presence__filters input[name="' + keyword + '"]').join(',');
    document.querySelectorAll(selectors).forEach(checkbox => {
      checkbox.addEventListener('click', this.applyFilter.bind(this));
    });

    //Reset filters button
    if( null !== document.querySelector('.media-presence__filters .reset-filters') ){
      document.querySelector('.media-presence__filters .reset-filters').addEventListener('click', (event) => {
        event.preventDefault();
        let checked_selectors = checkboxes.map(keyword => '.media-presence__filters input[name="' + keyword + '"]:checked').join(',');
        document.querySelectorAll(checked_selectors).forEach(checkbox => {
          checkbox.checked = false;
        });

        if( checked_selectors.length ) {
          this.applyFilter();
        }
        event.stopPropagation();
      });
    }

    /**
     * Latest Media Presence link
     */
    if( null !== document.querySelector('.media-presence__latest_link') ) {
      document.querySelector('.media-presence__latest_link').classList.toggle('media-presence__latest_link--hidden');
      document.querySelector('.media-presence__latest_link').addEventListener('click', (e) => {
        e.preventDefault();
        this.clearSearch();
        this.showLatestMediaPresenceView();
        e.currentTarget.classList.toggle('media-presence__latest_link--hidden');
        e.stopPropagation();
      });
    }
  }

  setupPaginationEvents() {
    /**
     * Pagination Events
     */
    document.querySelectorAll('.pagination__number:not(.pagination__number--current)').forEach(element => {
      element.addEventListener('click', this.queryPage.bind(this));
    });

    document.querySelectorAll('.pagination__symbol').forEach(element => {
      element.addEventListener('click', this.queryPage.bind(this));
    });
  }

  onSubmit() {
    document.querySelector('#media-presence_predictiveText .search-btn').click();
  }

  querySearch() {
    //if (document.querySelector('.research') != null && this.word != "undefined" ) {
    if (document.querySelector('.media-presence') != null && this.fq.length ) {
      this.clearResults();
      this.showSearchResultsView();
      this.showSpinner();
      let search_data = {
        arr_return_vars: [
          "title",
          "content",
          "resourcename",
          "description",
          "domain",
          "keywords",
          "image_src",
          "topic",
          "category",
          "date",
          "wp_text",
          "wp_double",
          "wp_text_array",
          "wp_double_array",
          "_score",
          "content_language",
        ],
        size: this.size,
        start: (this.current_page - 1) * this.size,
        options: "{fields:['title^5', 'topic^4', 'category^3', 'description^2']}",
        fq: this.fq,
        sort: '_score desc',
        parser: "lucene",
      };

      if (this.word != undefined && this.word != 'undefined') {
        search_data.keyword = this.word;
      }


      let search_options = {
        //mode: 'no-cors'
      };

      if ( location.host == this.prod_hosts[0] || location.host == this.sandbox_hosts[0] ) {
        search_options.headers = this.openweb_header;
      }

      fetch(this.parseSearchUrl(search_data), search_options)
        .then(response => response.json())
        .then(result => {
          //console.log(result);
          this.hideSpinner();
          let num_results = "0";
          if (result.data.hits != undefined) {
            //document.querySelector("#count").innerHTML = result.data.hits.found;
            if (result.data.hits.found > 0) {
              this.renderResults(result.data.hits.hit);
              this.renderPagination(result.data.hits.found);
              num_results = '' + result.data.hits.found;
            } else {
              this.showEmptyState();
              this.hideSearchResultsFooterView();
              document.querySelector('.media-presence-results').innerHTML = '';
            }
          }
          this.addTaggingInfo(this.word, num_results);
          window.ExperienceTheme.analytics.addIfCookiesEnabled();
        })
        .catch( err => {
          console.log("Error on fetch", err);
        });
    }
  }

  clearSearch() {
    document.querySelector('#media-presence_predictiveText .clear-btn').click();
  }

  clearResults() {
    let results_container = document.querySelector('.media-presence-results')
    results_container.innerHTML = '';
    results_container.scrollIntoView({behavior: 'smooth'});
    this.hidePagination();
  }

  renderResults(items = []) {
    let text_language = document.querySelector('html').getAttribute('lang').split('-')[0];
    const result_tpl = `<div class="card">
        <div class="card__editorial card__editorial--main">
            <div class="card__desc">
                <div class="content-title mobile-title">
                    <p class="grey600 result__right content-date">{{date}}</p>
                    <h6>
                        <a href="{{url}}" target="_blank" class="links" title="{{title}}">{{title}}</a>
                    </h6>
                </div>
                <div class="content-description">
                    <p class="body-copy ">{{description}}</p>
                </div>
                <div class="content-tags">{{{ keywords }}}</div>
            </div>
        </div>
    </div>`;

    let template = Handlebars.compile(result_tpl);
    let tag_prefix = '<span class="tag">';
    let tag_suffix = '</span>';

    let all_results = '';
    items.forEach(item => {
      //let wp_text = JSON.parse(item.fields.wp_text);
      //let profiles = wp_text.profiles;
      //let contacts = wp_text.contacts;

      let data = {
        url: item.fields.resourcename != undefined ? item.fields.resourcename : '',
        title: item.fields.title != undefined ? item.fields.title : '',
        //title_ref: item.fields.title != undefined ? item.fields.title : '',
        date: item.fields.date != undefined ? this.parseDate(item.fields.date, text_language) : '',
        description: item.fields.content != undefined ? item.fields.content : '',
        keywords: item.fields.category != undefined ? tag_prefix + item.fields.category + tag_suffix : '',
      };

      //for some reason, url is coming with https:/ instead of https://
      data.url = data.url.replace(/(https:\/)([aA-zZ])(.*)/, "$1/$2$3");

      let result = template(data);
      all_results += result;
    });

    let container = document.querySelector('.media-presence-results');
    container.innerHTML = all_results;
  }

  parseDate(date, locale) {
    let parsedDate = DateTime.fromISO(date).setLocale(locale).toFormat('LLLL y');
    return parsedDate;
  }

  showSpinner() {
    document.querySelector('.spinner').classList.add('spinner--active');
  }

  hideSpinner() {
    document.querySelector('.spinner').classList.remove('spinner--active');
  }

  showEmptyState() {
    document.querySelector('.card-empty-state').classList.add('card-empty-state--active');
  }

  hideEmptyState() {
    document.querySelector('.card-empty-state').classList.remove('card-empty-state--active');
  }

  showPagination() {
    document.querySelector('.pagination').classList.add('pagination--show');
  }

  hidePagination() {
    document.querySelector('.pagination').classList.remove('pagination--show');
  }

  showLatestMediaPresenceView() {
    this.hideSearchResultsView();
    this.hideSearchResultsFooterView();

    document.querySelector('.media-presence__latest-media').classList.remove('hide');
  }

  hideLatestMediaPresenceView() {
    document.querySelector('.media-presence__latest-media').classList.add('hide');
  }

  showSearchResultsView() {
    this.hideEmptyState();
    this.hideLatestMediaPresenceView();
    this.showSearchResultsFooterView();
    document.querySelector('.media-presence__results').classList.remove('hide');
  }

  hideSearchResultsView() {
    document.querySelector('.media-presence__results').classList.add('hide');
  }

  showSearchResultsFooterView() {
    document.querySelector('.media-presence__results--footer').classList.remove('hide');
  }

  hideSearchResultsFooterView() {
    document.querySelector('.media-presence__results--footer').classList.add('hide');
  }

  renderPagination(total = 0) {
    if (total === 0) {
      this.showEmptyState();
      this.hideSearchResultsFooterView();
    } else {
      this.hideEmptyState();
      this.showSearchResultsFooterView();
    }

    let text_language = document.querySelector('html').getAttribute('lang').split('-')[0];
    let previous_label = text_language=='es'?'Anterior':'Previous';
    let next_label = text_language=='es'?'Siguiente':'Next';
    let showing_label = text_language=='es'?'Mostrando':'Showing';
    let of_label = text_language=='es'?'de':'of';
    let results_label = text_language=='es'?'resultados':'results';
    let info = `${showing_label} ${this.size} ${of_label} ${total} ${results_label}`;

    let first = `<a class="pagination__symbol pagination__symbol--first ui-first" href="#"></a>`;
    let prev = Handlebars.compile(`<a class="pagination__symbol pagination__symbol--prev ui-back" href="#" title="{{ previous }}"></a>`);
    let next = Handlebars.compile(`<a class="pagination__symbol pagination__symbol--next ui-next" href="#" title="{{ next }}"></a>`);
    let last = `<a class="pagination__symbol pagination__symbol--last ui-end" href="#"></a>`;

    this.num_pages = Math.ceil(total / this.size);

    let pagination_str = '';
    if (this.current_page < this.num_pages) {
      if (this.current_page > 1) {
        pagination_str += first + prev({previous: previous_label});
      }

      pagination_str += this.getPageItems(total);
      pagination_str += next({next: next_label}) + last;
    } else if( this.current_page === this.num_pages ) {
      pagination_str += this.getPageItems(total);
    } else {
      pagination_str += first + prev({previous: previous_label});
      pagination_str += this.getPageItems(total);
    }

    if( this.num_pages > 1 ) {
      this.showPagination();
      document.querySelector('.pagination__items').innerHTML = pagination_str;
      document.querySelector('.pagination__information').innerText = info;
      this.setupPaginationEvents();
    }
  }

  applyFilter( runQuery = true ) {
    //reset current_page
    this.current_page = 1;
    let date = '';
    let category = '';
    //let description = '';
    //let wp_text_array = '';
    let wp_text = '';
    //let fq = `topic:'${this.topic}' content_language:'${this.default_fq.content_language}' `;
    let fq = `topic:'${this.topic}' description:'${window.search_description}'`;

    //Topic -> Category
    let selected_topic_nodes = document.querySelectorAll('input[name="topic"]:checked');
    if(selected_topic_nodes.length ) {
      if( selected_topic_nodes.length === 1 ) {
        category = `${[...selected_topic_nodes].map( topic_node => "category:'" + topic_node.value + "'" )}`;
      } else {
        category = `(or ${[...selected_topic_nodes].map( topic_node => "category:'" + topic_node.value + "'" ).join(' ')})`;
      }
      fq += category + " ";
    }

    //Date
    let selected_date_nodes = document.querySelectorAll('input[name="date"]:checked');
    if(selected_date_nodes.length ) {
      if( selected_date_nodes.length === 1 ) {
        date = `${[...selected_date_nodes].map( date_node => "date:['" + date_node.value + "-01-01T00:00:00Z','" + date_node.value + "-12-31T23:59:59Z']" )}`;
      } else {
        date = `(or ${[...selected_date_nodes].map( date_node => "date:['" + date_node.value + "-01-01T00:00:00Z','" + date_node.value + "-12-31T23:59:59Z']" ).join(' ')})`;
      }
      fq += date + " ";
    }

    //Profiles
    let selected_profile_nodes = document.querySelectorAll('input[name="profile"]:checked');
    if( selected_profile_nodes.length ) {
      if( selected_profile_nodes.length === 1 ) {
        wp_text = `${[...selected_profile_nodes].map( profile_node => "wp_text:'" + profile_node.value + "'" )}`;
      } else {
        wp_text = `(or ${[...selected_profile_nodes].map( profile_node => "wp_text:'" + profile_node.value + "'" ).join(' ')})`;
      }
      fq += wp_text + " ";
    }

    if (fq != '') {
      this.fq = "(and " + fq + " )";
    }

    //console.log(this.fq);
    if( runQuery ) {
      clearTimeout(this.filterTimer);
      this.filterTimer = setTimeout(()=> {
        this.querySearch();
      }, 3000);
    }
  }
}

export default MediaPresence
